/* MANDARINA REPUBLIC — HOME v6 · matriz de variantes en la tarjeta
   (color + talla sin salir de la grilla).

   Lo carga snippets/mrh-card.liquid, o sea que la etiqueta <script> se
   repite una vez por tarjeta: el guardia de abajo hace que el trabajo se
   haga UNA sola vez. El navegador descarga el archivo una sola vez igual. */
(function () {
  'use strict';
  if (window.__mrhVariantes) return;
  window.__mrhVariantes = true;

  var GRIS = '#8A7C6E';

  /* Los colores llegan como texto en español desde el admin. Los que no
     estén en esta tabla no se inventan: se dibujan como pastilla con el
     nombre escrito, que es honesto y no confunde. */
  var HEX = {
    'negro': '#17130F', 'gris': '#8A8A8A', 'plomo': '#7A7A7A', 'blanco': '#F5F1EC',
    'rojo': '#D22B22', 'vino': '#6E1420', 'amarillo': '#FFC400', 'mostaza': '#D9A400',
    'azul': '#2E5BE8', 'azul marino': '#1B2A6B', 'celeste': '#5BB8E8', 'turquesa': '#1FB6A8',
    'verde': '#2E9E3E', 'menta': '#9BD9B0', 'naranja': '#FF7A29', 'rosa': '#F07AA8',
    'fucsia': '#E0308C', 'morado': '#7B3FA0', 'púrpura': '#7B3FA0', 'purpura': '#7B3FA0',
    'lila': '#B9A0DE', 'marrón': '#6B4A2F', 'marron': '#6B4A2F', 'café': '#6B4A2F',
    'cafe': '#6B4A2F', 'beige': '#D8C3A5', 'crema': '#EFE3CF', 'clara': '#E6DCCB',
    'durazno': '#F5B78C', 'salmón': '#F08A70', 'salmon': '#F08A70', 'coral': '#F0705A',
    'dorado': '#C9A227', 'plateado': '#C0C0C0'
  };

  /* OJO con la especificidad: la hoja base trae `.mrh button { background: none;
     border: 0 }` (0,1,1). Un `.mrh-sw` suelto (0,1,0) PIERDE y las bolitas salen
     transparentes y sin borde — ya pasó. Por eso todo va prefijado con `.mrh`. */
  var CSS = [
    '.mrh .mrh-opts{display:flex;flex-direction:column;gap:5px}',
    '.mrh .mrh-optlabel{font-family:var(--mono);font-size:9px;text-transform:uppercase;letter-spacing:.09em;color:var(--mute-2)}',
    '.mrh .mrh-optlabel b{color:var(--paper);font-weight:700}',
    '.mrh .mrh-swatches{display:flex;flex-wrap:wrap;gap:6px}',
    '.mrh .mrh-sw{width:26px;height:26px;border-radius:50%;padding:0;flex:none;position:relative;background:var(--sw,' + GRIS + ');border:2px solid rgba(255,248,242,.3);transition:transform .12s ease,border-color .12s ease}',
    '.mrh .mrh-sw.is-on{border-color:#FFF8F2;transform:scale(1.12);box-shadow:0 0 0 2px rgba(0,0,0,.45)}',
    '.mrh .mrh-sw.is-off{opacity:.32;cursor:not-allowed}',
    '.mrh .mrh-sw.is-off::before{content:"";position:absolute;left:-2px;right:-2px;top:50%;height:2px;background:#E5342B;transform:rotate(-45deg)}',
    '.mrh .mrh-sw.is-text{width:auto;height:auto;min-width:26px;border-radius:10px;padding:5px 9px;background:transparent;color:var(--mute);font-family:var(--mono);font-size:10px;font-weight:700;text-transform:uppercase;line-height:1}',
    '.mrh .mrh-sw.is-text.is-on{background:var(--paper);color:var(--ink);border-color:var(--paper);transform:none;box-shadow:none}',
    '@media (prefers-reduced-motion: reduce){.mrh .mrh-sw{transition:none}}'
  ].join('');

  var st = document.createElement('style');
  st.textContent = CSS;
  document.head.appendChild(st);

  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function llave(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  function datos(card) {
    if (card.__mrhv !== undefined) return card.__mrhv;
    var tag = card.querySelector('[data-variants]');
    if (!tag) { card.__mrhv = null; return null; }
    try { card.__mrhv = JSON.parse(tag.textContent); }
    catch (e) { card.__mrhv = null; }
    return card.__mrhv;
  }

  /* ¿hay stock de esta combinación? (null = cualquiera) */
  function hay(vs, color, talla) {
    for (var k = 0; k < vs.length; k++) {
      var x = vs[k];
      if (!x.a) continue;
      if (color != null && llave(x.c) !== llave(color)) continue;
      if (talla != null && llave(x.s) !== llave(talla)) continue;
      return true;
    }
    return false;
  }

  function variante(vs, color, talla) {
    for (var k = 0; k < vs.length; k++) {
      var x = vs[k];
      if (x.a && llave(x.c) === llave(color) && llave(x.s) === llave(talla)) return x;
    }
    return null;
  }

  function pintar(card) {
    var vs = datos(card);
    if (!vs || !vs.length) return;
    var color = card.getAttribute('data-color');
    var talla = card.getAttribute('data-talla');

    /* colores: se tacha el que no tenga NINGUNA talla en stock */
    var sws = card.querySelectorAll('[data-opt="color"]');
    for (var i = 0; i < sws.length; i++) {
      var b = sws[i], v = b.getAttribute('data-val'), tono = HEX[llave(v)];
      if (tono) { b.style.setProperty('--sw', tono); b.classList.remove('is-text'); }
      else { b.classList.add('is-text'); if (!b.textContent) b.textContent = v; }
      var vivo = hay(vs, v, null);
      b.classList.toggle('is-off', !vivo);
      b.classList.toggle('is-on', llave(v) === llave(color));
      b.setAttribute('aria-pressed', llave(v) === llave(color) ? 'true' : 'false');
    }

    /* tallas: se apagan las que no existan EN EL COLOR ELEGIDO */
    var chips = card.querySelectorAll('[data-opt="talla"]');
    for (var j = 0; j < chips.length; j++) {
      var c = chips[j], t = c.getAttribute('data-val');
      var viva = hay(vs, color, t);
      c.disabled = !viva;
      c.classList.toggle('is-on', viva && llave(t) === llave(talla));
    }

    var etiqueta = card.querySelector('[data-color-label]');
    if (etiqueta) etiqueta.textContent = color || '';

    /* variante resuelta → el botón de añadir y el precio */
    var m = (color && talla) ? variante(vs, color, talla) : null;
    var cta = card.querySelector('[data-add]');
    if (cta) {
      if (m) {
        cta.setAttribute('data-variant', m.i);
        cta.textContent = 'Añadir al carrito';
      } else {
        cta.removeAttribute('data-variant');
        cta.textContent = color ? 'Elige tu talla' : 'Elige color y talla';
      }
    }
    if (m) precio(card, m);
  }

  function precio(card, m) {
    var caja = card.querySelector('.mrh-price');
    if (!caja) return;
    var b = caja.querySelector('b');
    if (b) b.textContent = money(m.p);
    var s = caja.querySelector('s');
    if (m.cp && m.cp > m.p) {
      if (!s) { s = document.createElement('s'); caja.appendChild(s); }
      s.textContent = money(m.cp);
      s.hidden = false;
    } else if (s) {
      s.hidden = true;
    }
  }

  /* Al elegir color: si en ese color solo queda UNA talla, se marca sola
     (no hay ambigüedad posible y ahorra un toque). Si son varias, la elige
     la persona: una talla equivocada no es una venta, es una devolución. */
  function tallaUnica(vs, color) {
    var vistas = [], k, x;
    for (k = 0; k < vs.length; k++) {
      x = vs[k];
      if (x.a && llave(x.c) === llave(color) && vistas.indexOf(llave(x.s)) < 0) vistas.push(llave(x.s));
    }
    if (vistas.length !== 1) return null;
    for (k = 0; k < vs.length; k++) {
      x = vs[k];
      if (x.a && llave(x.c) === llave(color)) return x.s;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-opt]') : null;
    if (!b) return;
    var card = b.closest('[data-card]');
    if (!card) return;
    var vs = datos(card);
    if (!vs) return;
    e.preventDefault();

    var val = b.getAttribute('data-val');
    if (b.getAttribute('data-opt') === 'color') {
      if (b.classList.contains('is-off')) return;
      card.setAttribute('data-color', val);
      var t = card.getAttribute('data-talla');
      if (t && !hay(vs, val, t)) card.removeAttribute('data-talla');
      var sola = tallaUnica(vs, val);
      if (sola) card.setAttribute('data-talla', sola);
    } else {
      if (b.disabled) return;
      card.setAttribute('data-talla', val);
    }
    pintar(card);
  });

  function init() {
    var cards = document.querySelectorAll('[data-card]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__mrhInit) continue;
      var vs = datos(card);
      if (!vs || !vs.length) continue;
      card.__mrhInit = true;
      /* el color arranca elegido — la foto de la tarjeta ya muestra uno */
      if (!card.getAttribute('data-color')) {
        for (var k = 0; k < vs.length; k++) {
          if (vs[k].a) { card.setAttribute('data-color', vs[k].c); break; }
        }
      }
      var col = card.getAttribute('data-color');
      if (col) {
        var sola = tallaUnica(vs, col);
        if (sola) card.setAttribute('data-talla', sola);
      }
      pintar(card);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
